import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import theme from "../../../../theme";
import Hyperlink from "../../../Hyperlink";

const StepWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  padding: ${theme.margins.paddingPage} 0;
  text-transform: normal;
  align-items: flex-start;
`;

const Price = styled.span`
  white-space: nowrap;
`;

interface IStepLabelProps {
  color?: string;
}

const StepLabel = styled.div<IStepLabelProps>`
  margin: 0;
  color: ${({ color }: IStepLabelProps): string => color || theme.colors.black};
  width: 100%;
  font-size: 15px;
  font-weight: normal;
`;

const StyledHyperlink = styled(Hyperlink)`
  flex-grow: 1;
`;

const StepLabelWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const StepSubLabel = styled(StepLabel)`
  margin-top: 3px;
`;

interface IProps {
  label: string;
  subLabel?: string | ReactNode;
  productUrl?: string;
  price?: string;
  onClick?: () => void;
}

export default class VerticalStepName extends PureComponent<IProps> {
  public render(): ReactNode {
    const { label, subLabel, productUrl, price, onClick } = this.props;

    return (
      <StepWrapper>
        <StepLabelWrapper>
          <StyledHyperlink to={productUrl} onClick={onClick}>
            <StepLabel>{label}</StepLabel>
          </StyledHyperlink>
          {price ? <Price className="price">{price}</Price> : null}
        </StepLabelWrapper>

        {subLabel && (
          <StepSubLabel color={theme.colors.grey}>{subLabel}</StepSubLabel>
        )}
      </StepWrapper>
    );
  }
}
